import { delay, Glow, iconClassName, styles, svgProps } from '@/components/service-showcase/icons/shared';
import type { IServiceShowcaseSvgIconProps } from '@/components/service-showcase/icons/type';

// Constellation nodes — A,D,E are on the glowing value path; B,C are background nodes
const FAINT_LINES = [
  { x1: 65, y1: 72, x2: 188, y2: 40 },
  { x1: 188, y1: 40, x2: 305, y2: 72 },
  { x1: 65, y1: 72, x2: 132, y2: 150 },
  { x1: 132, y1: 150, x2: 188, y2: 40 },
  { x1: 132, y1: 150, x2: 262, y2: 168 },
  { x1: 262, y1: 168, x2: 305, y2: 72 },
  { x1: 132, y1: 150, x2: 305, y2: 72 },
];

const FAINT_NODES = [
  { cx: 188, cy: 40, d: 0.15 },
  { cx: 305, cy: 72, d: 0.2 },
];

const VALUE_NODES = [
  { cx: 65, cy: 72, r: 5, d: 0.05 },
  { cx: 132, cy: 150, r: 6, d: 0.5 },
  { cx: 262, cy: 168, r: 5, d: 1.1 },
];

export default function ConstellationMapIcon(props: IServiceShowcaseSvgIconProps) {
  const { active = true, className, ...rest } = props;

  return (
    <svg {...svgProps} {...rest} className={iconClassName(active, className)}>
      <Glow cx={132} cy={150} r={26} opacity={0.2} />
      <Glow cx={262} cy={168} r={22} opacity={0.18} />

      {/* Faint background web */}
      {FAINT_LINES.map(({ x1, y1, x2, y2 }) => (
        <line
          key={`${x1}-${y1}-${x2}-${y2}`}
          x1={x1} y1={y1} x2={x2} y2={y2}
          stroke='currentColor' strokeOpacity='0.14' strokeWidth='1.2'
        />
      ))}

      {/* Background nodes */}
      {FAINT_NODES.map(({ cx, cy, d }) => (
        <circle
          key={`${cx}-${cy}`}
          cx={cx} cy={cy} r={4}
          fill='currentColor' fillOpacity='0.4'
          className={styles.pop} style={delay(`${d}s`)}
        />
      ))}

      {/* Glowing value path */}
      <polyline
        points='65,72 132,150 262,168'
        stroke='currentColor' strokeWidth='2' strokeOpacity='0.85'
        fill='none' pathLength='1'
        className={styles.link} style={delay('0.25s')}
      />

      {/* Value path nodes */}
      {VALUE_NODES.map(({ cx, cy, r, d }) => (
        <circle
          key={`${cx}-${cy}`}
          cx={cx} cy={cy} r={r}
          fill='currentColor' fillOpacity='0.9'
          className={styles.pop} style={delay(`${d}s`)}
        />
      ))}

      {/* Ambient pulse on peak value node */}
      <circle
        cx={262} cy={168} r={10}
        stroke='currentColor' strokeOpacity='0.4' fill='none'
        className={styles.sourcePulse}
        style={{ transformBox: 'fill-box', transformOrigin: 'center' }}
      />

      <text x='42' y='67' fill='currentColor' fillOpacity='0.35' fontSize='8' fontFamily='monospace' letterSpacing='0.12em'>SIGNAL</text>
      <text x='248' y='183' fill='currentColor' fillOpacity='0.35' fontSize='8' fontFamily='monospace' letterSpacing='0.08em'>HIGH VALUE</text>
    </svg>
  );
}
